<template>
  <Modal title="查看买断时间" v-model="visible"
    width="450">
      <Form ref="form" class="form" :label-width="100">
        <Row>
          <Col :span="24" >
            <Form-item label="买断时间" style="margin-bottom:0px">
              <Checkbox-group v-model="openedTimeIdList">
                <Checkbox v-for="item in openedTimeList" :key="item.id" :label="item.id">
                  <span>{{ item.weekStr }} {{ item.startTimeStr }} - {{ item.endTimeStr }}</span>
                </Checkbox>
              </Checkbox-group>
            </Form-item>
          </Col>
        </Row>
      </Form>
    <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
      </div>
    </Modal>
</template>
<script>
  export default {
    name: 'TchCancelOpenedTimeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingCancel: false,
        openedTimeIdList: [],
        openedTimeList: []
      }
    },
    methods: {
      loadTchOpenedTime () {
        let loadMsg = this.$Message.loading({
          content: '正在加载中...',
          duration: 0
        })
        let self = this

        self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
          if (!res || !res.data) {
            return
          }
          loadMsg()
          self.visible = true
          res.data.forEach(function (element) {
            element.weekStr = self.$constant.weekZh[element.week]
            element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm')
            element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm')
            self.openedTimeIdList.push(element.id)
            self.openedTimeList.push(element)
          })
        })
      },
      canceOpenedTime () {
        let self = this
        let ids = []
        let openedTimeIdList = this.openedTimeIdList
        this.openedTimeList.forEach(element => {
          openedTimeIdList.includes(element.id) || ids.push(element.id)
        })
        if (ids.length <= 0) {
          self.visible = false
          return
        }
        self.loadingCancel = true
        let params = {}
        params.tchId = self.tchId
        params.openedTimeIds = ids.join(',')
        self.$http.post('/tch/time/cancelBookOpenedTime', params).then(function (res) {
          self.loadingCancel = false
          let data = res.data
          if (data || data.length <= 0) {
            self.successCallback()
            self.visible = false
          } else {
            let content = '与学生上课时间冲突：</br>'
            data.forEach(element => {
              content += ('<b>' + self.$constant.weekZh[element.week] + ' ' +
                self.$moment.unix(element.startTime).utc().format('HH:mm') + ' - ' +
                self.$moment.unix(element.endTime).utc().format('HH:mm')) + '</b></br>'
            })
            self.$Message.error({
              content: content,
              duration: 3
            })
          }
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.openedTimeList = []
          this.openedTimeIdList = []
          this.loadTchOpenedTime()
        } else {
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchCancelOpenedTimeModal.vue?12aace80